__turbopack_context__.v({
  "column": "ApplyFormDetails-module__frQW6W__column",
  "columns": "ApplyFormDetails-module__frQW6W__columns",
  "container": "ApplyFormDetails-module__frQW6W__container",
  "divider": "ApplyFormDetails-module__frQW6W__divider",
  "dobFields": "ApplyFormDetails-module__frQW6W__dobFields",
  "dobInput": "ApplyFormDetails-module__frQW6W__dobInput",
  "fadeInItems": "ApplyFormDetails-module__frQW6W__fadeInItems",
  "field": "ApplyFormDetails-module__frQW6W__field",
  "input": "ApplyFormDetails-module__frQW6W__input",
  "selectField": "ApplyFormDetails-module__frQW6W__selectField",
  "selectInput": "ApplyFormDetails-module__frQW6W__selectInput",
  "selectOption": "ApplyFormDetails-module__frQW6W__selectOption",
  "selectOptions": "ApplyFormDetails-module__frQW6W__selectOptions",
  "spacing--lg": "ApplyFormDetails-module__frQW6W__spacing--lg",
  "spacing--md": "ApplyFormDetails-module__frQW6W__spacing--md",
  "spacing--sm": "ApplyFormDetails-module__frQW6W__spacing--sm",
  "spacing--xl": "ApplyFormDetails-module__frQW6W__spacing--xl",
  "spacing--xs": "ApplyFormDetails-module__frQW6W__spacing--xs",
  "spacing--xxl": "ApplyFormDetails-module__frQW6W__spacing--xxl",
  "spacing--xxs": "ApplyFormDetails-module__frQW6W__spacing--xxs",
  "spacing--xxxl": "ApplyFormDetails-module__frQW6W__spacing--xxxl",
  "spacing--xxxs": "ApplyFormDetails-module__frQW6W__spacing--xxxs",
  "surname": "ApplyFormDetails-module__frQW6W__surname",
  "text": "ApplyFormDetails-module__frQW6W__text",
  "title": "ApplyFormDetails-module__frQW6W__title",
});
